import { gql } from '@apollo/client';

export default gql`
  mutation updateCustomer($bookingReference: String!, $customer: CustomerInput!) {
    updateCustomer(bookingReference: $bookingReference, customer: $customer) {
      reference
    }
  }
`;
